export default __webpack_public_path__ + "static/media/empty.3479f6e0.svg";